































































































































import { Component, Mixins } from 'vue-property-decorator'
import UnitDetailMixin from '@/components/mixins/UnitDetailListMixin.vue'
import FloorModel from '@/_models/FloorModel'
import { mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapGetters('common', {
      fullThumbImageUrl: 'fullThumbImageUrl'
    })
  }
})
export default class FloorList extends Mixins(UnitDetailMixin) {
  public filedNameLUT: any = {
    name: 'label.floor_name',
    building_name: 'label.building_name'
  }
  get floors(): FloorModel[] {
    const floors = this.$store.state.units.all.floors
    this.numofPage = Math.ceil(floors.length / this.pageFilters.perPage)

    return floors
  }

  get filteredData(): FloorModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.floors) {
      return []
    }

    return this.floors.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1 ||
        item._id === this.pageFilters.searchQuery // Can search by uuid
      )
    })
  }

  public confirmMultiDelete() {
    const ids = this.checkedRows.map((item: FloorModel) => item._id)
    const labels = this.checkedRows.map(
      (item: FloorModel) => item.building_name + ' - ' + item.name
    )
    this.handleConfirmMultipleDelete('floor', ids, labels)
  }

  public confirmSingleDelete(selectedItem: FloorModel) {
    const ids = [selectedItem._id]
    const labels = [selectedItem.building_name + ' - ' + selectedItem.name]
    this.handleConfirmMultipleDelete('floor', ids, labels)
  }

  private created() {
    this.$store.dispatch('units/getAllFloors', this.selected)
  }
}
